import { MobiDocument } from './MobiDocument';
import { MaladieDocument } from './MaladieDocument';

export class IndividuMaladieDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private maladie_id: number;
    private individu_id: number;
    private date: string;

    public constructor(indMaladie: any) {
        super()
        this._id = indMaladie._id;
        this._rev = indMaladie._rev;
        this.id = indMaladie.id;
        this.maladie_id = indMaladie.maladie_id;
        this.individu_id = indMaladie.individu_id;
        this.date = indMaladie.date;
    }
    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getMaladie_id(): number {
        return this.maladie_id;
    }

    public setMaladie_id(maladie_id: number): void {
        this.maladie_id = maladie_id;
    }

    public getIndividu_id(): number {
        return this.individu_id;
    }

    public setIndividu_id(individu_id: number): void {
        this.individu_id = individu_id;
    }

    public getMaladie(): MaladieDocument {
        let maladie = this.memdb.findOne({
            doctype: "MaladieDocument",
            fkey: "id",
            fvalue: this.maladie_id
        });
        let maladieDoc = new MaladieDocument(maladie);
        maladieDoc.setDate(this.date);
        return maladieDoc;
    }

    public getDate(): string {
        return this.date;
    }

    public setDate(date: string): void {
        this.date = date;
    }

}